import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as S from './styles';
import { ActionButtonProps, ActionButtonsProps } from './types';

const ActionButtons: React.FC<ActionButtonsProps> = ({ buttons, wrapperStyle }) => {
  if (!buttons || buttons.length === 0) {
    return null;
  }

  return (
    <S.ButtonsContainer style={wrapperStyle}>
      {buttons.map((buttonProps, index) => {
        const {
          icon,
          title,
          backgroundColor,
          onClick,
          type = 'button',
          ...restProps
        } = buttonProps;

        const isFirst = index === 0;
        const isLast = index === buttons.length - 1;

        return (
          <S.ActionButton
            key={index}
            type={type}
            onClick={onClick}
            backgroundColor={backgroundColor}
            isFirst={isFirst}
            isLast={isLast}
            title={title}
            {...restProps}
          >
            <FontAwesomeIcon icon={icon} />
          </S.ActionButton>
        );
      })}
    </S.ButtonsContainer>
  );
};

export default ActionButtons;
